// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__24JE4","large":"styles_large__15YfH"};